export const useMatchReducerFunctions = dispatch => {
  const setCargandoMatch = isCargandoMatch => {
    dispatch({ type: 'SET_IS_CARGANDO_MATCH', payload: isCargandoMatch });
  };

  const setIsCargandoMatchResiduos = isCargando => {
    dispatch({ type: 'SET_IS_CARGANDO_MATCH_RESIDUOS', payload: isCargando });
  };

  const setIsCargandoMatchEmpresas = isCargando => {
    dispatch({ type: 'SET_IS_CARGANDO_MATCH_EMPRESAS', payload: isCargando });
  };

  const setCargandoListaEmpresas = isCargando => {
    dispatch({ type: 'SET_IS_CARGANDO_EMPRESAS', payload: isCargando });
  };

  const setCargandoListaSucursales = isCargando => {
    dispatch({ type: 'SET_IS_CARGANDO_SUCURSALES', payload: isCargando });
  };

  const setCargandoListaResiduosRecursos = isCargando => {
    dispatch({
      type: 'SET_IS_CARGANDO_RESIDUOS_RECURSOS',
      payload: isCargando
    });
  };

  const setIsCargandoMatchAmpliado = isCargando => {
    dispatch({ type: 'SET_IS_CARGANDO_MATCH_AMPLIADO', payload: isCargando });
  };

  const setMatchStep = matchStep => {
    dispatch({ type: 'SET_MATCH_STEP', payload: matchStep });
  };

  const setMatch = match => {
    dispatch({ type: 'SET_MATCH', payload: match });
  };

  const setMatchEmpresas = matchEmpresas => {
    dispatch({ type: 'SET_MATCH_EMPRESAS', payload: matchEmpresas });
  };

  const setMatchAmpliado = matchAmpliado => {
    dispatch({ type: 'SET_MATCH_AMPLIADO', payload: matchAmpliado });
  };

  const setOrdenarMatch = (ev, ordenamiento) => {
    dispatch({ type: 'SET_ORDENAR_MATCH', payload: ordenamiento });
  };

  const setIsNuevosCriterios = value => {
    dispatch({ type: 'SET_IS_NUEVOS_CRITERIOS', payload: value });
  };

  const setState = state => {
    dispatch({ type: 'SET_STATE', payload: state });
  };

  const setMatchFiltrado = matchFiltrado => {
    dispatch({ type: 'SET_MATCH_FILTRADO', payload: matchFiltrado });
  };

  const setRadioBusqueda = radioBusqueda => {
    dispatch({ type: 'SET_RADIO_BUSQUEDA', payload: radioBusqueda });
  };

  const setCoordenadasCentroMapa = coordenadas => {
    dispatch({ type: 'SET_COORDENADAS_CENTRO_MAPA', payload: coordenadas });
  };

  const setResiduoSeleccionado = item => {
    dispatch({ type: 'SET_SELECCIONAR_ITEM', payload: item });
  };

  const setSucursalUsuario = usuario => {
    dispatch({ type: 'SET_SUCURSAL_USUARIO', payload: usuario });
  };

  const setTransacciones = transacciones => {
    dispatch({ type: 'SET_TRANSACCIONES', payload: transacciones });
  };

  const setEmpresaSeleccionada = empresaSeleccionada => {
    dispatch({
      type: 'SET_EMPRESA_SELECCIONADA',
      payload: empresaSeleccionada
    });
  };

  const setSucursalATSeleccionada = item => {
    dispatch({ type: 'SET_SELECCIONAR_EMPRESAAT', payload: item });
  };

  const setSucursalSeleccionado = item => {
    dispatch({ type: 'SET_SELECCIONAR_EMPRESA', payload: item });
  };

  const setSalasChat = salasChat => {
    dispatch({ type: 'SET_SALAS_CHAT', payload: salasChat });
  };

  const setTabActiva = tab => {
    dispatch({ type: 'SET_TAB_ACTIVA', payload: tab });
  };

  const setFiltrosAplicados = filtrosActivos => {
    dispatch({ type: 'SET_FILTROS_APLICADOS', payload: filtrosActivos });
  };

  return {
    setOrdenarMatch,
    setIsNuevosCriterios,
    setMatchFiltrado,
    setRadioBusqueda,
    setCoordenadasCentroMapa,
    setResiduoSeleccionado,
    setSucursalSeleccionado,
    setSucursalATSeleccionada,
    setSucursalUsuario,
    setTransacciones,
    setTabActiva,
    setState,
    setEmpresaSeleccionada,
    setMatchStep,
    setFiltrosAplicados,
    setSalasChat,
    setMatchAmpliado,
    setMatchEmpresas,
    setMatch,
    setIsCargandoMatchAmpliado,
    setCargandoListaSucursales,
    setCargandoListaEmpresas,
    setIsCargandoMatchEmpresas,
    setIsCargandoMatchResiduos,
    setCargandoListaResiduosRecursos,
    setCargandoMatch
  };
};
